import React from "react";

// reactstrap components
import { Container, Row } from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";

import SimpleFooter from "components/Footers/SimpleFooter.js";

// index page sections
import Hero from "./IndexSections/Hero.js";
import {
  Button,
  Col,
} from "reactstrap";

class Index extends React.Component {
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }
  render() {
    return (
      <>
        <DemoNavbar />
        <main ref="main">
          <Hero />
          <Container>
            <Row className=" row-grid align-items-center mb-5">
              <Col lg="6">
                <h6 className=" text-dark font-weight-light mb-2 mt-3">
                  Developer Student Clubs (DSC) is a programme in collaboration
                  with Google that targets passionate students from developer
                  communities across the globe. Be it Android, Cloud or Data
                  Science - this is a unique platform for students to not just
                  learn through P2P workshops but solve actual real-world
                  problems for the local community through sponsored projects.
                  IIT Indore is now part of the few institutes that have been
                  selected for this program.
                </h6>
                <div className="btn-wrapper mt-3">
                  <Button
                    className="btn-white mb-3 mb-sm-0"
                    href="https://developers.google.com/community/dsc"
                    size="sm"
                  >
                    <span className="btn-inner--text">Know more</span>
                  </Button>
                </div>
              </Col>
            </Row>

            <h3 className="text-dark font-weight-light">Club Recruitments</h3>
            <h6 className="text-dark font-weight-light">
              DSC IITI Core Team will have 2 divisions: the Technical division
              and the Non-Technical division.
              <p className=" text-dark font-weight-light mb-2 mt-3">
                {" "}
                We expect students applying for the technical team to have
                passion as well as relevant experience in the fields of{" "}
                <b> Android, Web Technologies, ML or Cloud </b> so that they can
                regularly collaborate for interactive workshops on the same.
              </p>{" "}
              Similarly, the non-technical team to have relevant experience in
              management and/or operations with a general inclination towards
              technology.
              <p className=" text-dark font-weight-light mb-2 mt-3">
                {" "}
                So if you think that you have the skills and the passion to be a
                part of the ambitious DSC core team,<b> register yourself!</b>
              </p>
            </h6>
            <hr />
            <Row className=" row-grid align-items-center mb-5">
              <img
                alt="..."
                className="img-fluid"
                src={require("assets/img/brand/DSC_LH.png")}
                style={{ width: "400px" }}
              />
            </Row>
          </Container>
          {/*
          <Buttons />
          <Inputs />
          <section className="section">
            <Container>
              <CustomControls />
              <Menus />
            </Container>
          </section>
          <Navbars />
          <section className="section section-components">
            <Container>
              <Tabs />
              <Row className="row-grid justify-content-between align-items-center mt-lg">
                <Progress />
                <Pagination />
              </Row>
              <Row className="row-grid justify-content-between">
                <Pills />
                <Labels />
              </Row>
              <Alerts />
              <Typography />
              <Modals />
              <Datepicker />
              <TooltipPopover />
            </Container>
          </section>
          <Carousel />
          <Icons />
          <Login />
          <Download />
          */}
        </main>
        <SimpleFooter />
      </>
    );
  }
}

export default Index;
